import React from "react";
import NavBarComponent from "../../NavBarComponent";
import { internalLinks, links } from "./navigationLinks";

const index = () => {
  return <NavBarComponent links={links} />;
};

export default index;
